import React, { FC } from 'react';

import { Box, Center, Stack, Image } from '@chakra-ui/react';
import channelDetails from 'images/Slack/Slack-channel-ID.svg';
import channelOptions from 'images/Slack/Slack-get-channel-ID.svg';

export const GetChannelID: FC = () => {
  return (
    <Stack px={4} spacing={6} pt={4} w="full">
      <Box>
        Log in to your workspace in Slack via a web browser or app. Right click
        on the channel name and click on "View channel details". Copy channel ID
        at bottom.
      </Box>
      <Box w="full">
        <Center>
          <Image boxSize="30%" src={channelOptions} alt="Channel options" />
        </Center>
      </Box>
      <Center>
        <Image boxSize="70%" src={channelDetails} alt="Channel details" />
      </Center>
    </Stack>
  );
};
